<template lang="html">
  <div class="item-image-wrapper">
    <div class="item-image" :style="{ backgroundImage: 'url(' + itemImage + ')' }" alt="item image"></div>
    <div :class="{ active : hover}" class="hover-overlay">
      <div class="corner-wrapper">
        <img class="corner" src="@/assets/icons/upperLeftHoverCorner.png" alt="hover decoration corners">
      </div>
      <div class="btn-wrapper">
        <div v-if="!myProduct">
          <div @click="changeFavorite(true)" v-if="userIsLoged && !favorite" class="btn">
            <img src="@/assets/icons/favorite.png" alt="favorite button">
            <span>{{$t('item.favorite')}}</span>
          </div>
          <div @click="changeFavorite(false)" v-if="userIsLoged && favorite" class="btn">
            <img src="@/assets/icons/favorite.png" alt="favorite button">
            <span>{{$t('item.remove')}}</span>
          </div>
        </div>
        <div @click="$emit('details')" class="btn">
          <img src="@/assets/icons/magnefier.png" alt="details button">
          <span>{{$t('item.details')}}</span>
        </div>
      </div>
      <div class="corner-wrapper right">
        <img class="corner" src="@/assets/icons/bottomRightHoverCorner.png" alt="hover decoration corners">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'itemImage',
  props: {
    itemImage: {
      required: false,
      type: String
    },
    hover: {
      type: Boolean,
      default: false
    },
    favorite: {
      type: Boolean,
      default: false
    },
    id: {
      required: true,
      type: Number
    },
    myProduct: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState(['userIsLoged'])
  },
  methods: {
    changeFavorite (res) {
      let params = {
        pro_id: this.id
      }
      if (res) {
        api.addFavorite(params).then(res => {
          eventBus.$emit('refresh')
          this.$store.commit('changeFavoritesLength')
          this.$toast.success(this.$t('toast.addToFavorites'), {
            duration: 8000
          })
        }).catch(e => {
          console.log(e)
        })
      } else {
        api.removeFavorite(params).then(res => {
          eventBus.$emit('refresh')
          this.$store.commit('changeFavoritesLength')
          this.$toast.success(this.$t('toast.removeFromFavorites'), {
            duration: 8000
          })
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item-image-wrapper {
  width: 250px;
  height: 250px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .item-image {
    height: 100%;
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background-color: rgba(233, 120, 110, 0.0);
    opacity: 0;
    transition-duration: 0.2s;
    display: flex;
    flex-direction: column;

    .btn-wrapper {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .btn {
        width: 140px;
        height: 40px;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        margin-bottom: 15px;
        cursor: pointer;

        img {
          margin-right: 10px;
        }
        span {
          font-weight: bold;
          font-size: 12px;
          line-height: 20px;
          letter-spacing: 0.04em;
          color: $main-text-color;
          text-transform: uppercase;
          margin-top: 2px;
        }
      }
    }
    .corner-wrapper {
      width: 10px;
      padding: 10px;
      display: flex;
    }
    .corner-wrapper.right {
      margin-left: auto;
    }
    .corner {
      height: 10px;
    }
  }
  .hover-overlay.active {
    background-image: linear-gradient(90.45deg, rgba(139, 61, 76, 0.93) -1.87%, rgba(107, 51, 73, 0.93) 101.6%);
    opacity: 1;
  }
}
</style>
